import { PolygonCollider2D } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    namespace PolygonCollider2D {
        enum EventType {
            COLLIDER_POINTS_CHANGE = 'COLLIDER_POINTS_CHANGE',
        }
    }
}

enum EventType {
    COLLIDER_POINTS_CHANGE = 'COLLIDER_POINTS_CHANGE',
}

if (PolygonCollider2D) {
    PolygonCollider2D.EventType = EventType;

    const pointsDescriptor = Object.getOwnPropertyDescriptor(PolygonCollider2D.prototype, 'points');
    const pointsSetter = pointsDescriptor?.set;
    if (pointsDescriptor && pointsSetter) {
        pointsDescriptor.set = function set(this: PolygonCollider2D, value: PolygonCollider2D['points']): void {
            pointsSetter.call(this, value);
            this.emit(PolygonCollider2D.EventType.COLLIDER_POINTS_CHANGE, value);
        };
        Object.defineProperty(PolygonCollider2D.prototype, 'points', pointsDescriptor);
    }
}
